import React from 'react';

import FileDragTarget, {FileDragTargetProps} from 'util/drag-and-drop/FileDragTarget';

function OptionalFileDragTarget({
  enabled,
  ...props
}: FileDragTargetProps & {
  enabled: boolean;
}): JSX.Element {
  if (!enabled) {
    return React.createElement(props.component, null, props.children);
  }
  return <FileDragTarget {...props}>{props.children}</FileDragTarget>;
}

export default OptionalFileDragTarget;
